module.exports = __webpack_public_path__ + "img/4-5-media-mesh-2.a9ba6237.jpg";